module.exports = "<div class=\"y-checkbox\" data-bind=\"foreach: {data: dataList, as: 'item'}, css:{'y-checkbox-hor':direction == 'horizontal','y-checkbox-ver':direction == 'vertical'}\">\n  <y-checkbox-item params=\"fieldid: $parent.fieldid, disabled: item.disabled, secondarylabel: item.secondarylabel, label: item.label, value: item.value, valueList: $parent.value\"></y-checkbox-item>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/checkbox/index.html
// module id = 210
// module chunks = 0